import {useEffect, useState} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import {getProfile, getStarsById} from '../core/_requests'
import Swal from 'sweetalert2'
import {TStarProgressResponse, TStarResponse} from '../../../coreGlobal/models/franchise/franchise'
import {formatMonetaryToBr} from '../../../utils/formatMonetaryToBr'

type Props = {
  franchiseId: number | string
  starProgress: TStarProgressResponse
}

const StarDetails = ({franchiseId, starProgress}: Props) => {
  const starDisplay = (total: number, active: number) => {
    return Array.from({length: total}, (_, index) => {
      const isActive = index < active
      return (
        <KTIcon
          key={index}
          iconName='ki-duotone ki-star'
          className={`fs-3 me-2 ${isActive ? 'text-warning' : 'text-muted'}`}
        />
      )
    })
  }

  const [stars, setStars] = useState<TStarResponse>([])

  useEffect(() => {
    const star = async () => {
      try {
        const data = await getStarsById(String(franchiseId))
        setStars(data)
      } catch (error: any) {
        await Swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text: error.response.data.message,
        })
      } finally {
        //   setLoadingPage(false)
      }
    }
    star()
  }, [franchiseId])

  return (
    <>
      <div className='row'>
        <div className='col-6'>
          <div className='card mb-5 mb-xl-10'>
            {/* <div className='card-header border-0'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>Estrelas</h3>
              </div>
            </div> */}

            <div className='card-body border-top p-9'>
              <div>{starDisplay(5, starProgress?.current_star?.stars_count)}</div>
              <div className='table-responsive'>
                <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                  <tbody>
                    <tr>
                      <td>
                        <b>Valor Vendido:</b> {formatMonetaryToBr(starProgress?.total_sold)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b>Próxima Estrela:</b>{' '}
                        {starProgress?.current_star?.stars_count === 5
                          ? starProgress?.current_star?.stars_count
                          : starProgress?.current_star?.stars_count + 1}{' '}
                        Estrelas
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b>Meta para Próxima Estrela:</b>{' '}
                        {formatMonetaryToBr(starProgress?.current_star?.min_amount)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <b>Restante para Próxima Estrela:</b>{' '}
                        {formatMonetaryToBr(starProgress?.remaining)}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3'>
                          <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
                            <span className='fw-bolder fs-6'>{starProgress?.percentage}%</span>
                          </div>
                          <div className='h-5px mx-3 w-100 bg-light mb-3'>
                            <div
                              className='bg-success rounded h-5px'
                              role='progressbar'
                              style={{width: `${starProgress?.percentage}%`}}
                            ></div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className='col-6'>
          <div className='card mb-5 mb-xl-10'>
            <div className='card-header border-0'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>Tabela de Estrelas</h3>
              </div>
            </div>

            <div className='card-body border-top p-9'>
              <div className='table-responsive'>
                <table className='table table-bordered table-row-gray-300 gy-7'>
                  <thead className='fw-bold'>
                    <tr>
                      <th>Estrela</th>
                      <th>Meta de Vendas por Estrela</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stars?.map((star) => (
                      <tr key={star.id}>
                        <td>{starDisplay(5, star.starsCount)}</td>
                        <td>{`${formatMonetaryToBr(star?.minAmount)} - ${formatMonetaryToBr(
                          star?.maxAmount
                        )}`}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export {StarDetails}
